import { Alert, Box, Button, Typography } from "@mui/joy";
import { Paper } from "../atoms/paper";
import { Memo } from "./memo";
import { useMissionMap } from "../templates/projectInvite";
import { alpha } from "@mui/material";
import { AskForRelease } from "./askForRelease";
import { SeasonCalendar } from "./seasonCalendar";
import { useDispatch } from "react-redux";
import { setSelectedBookletToken } from "../redux/rhapsodyReducer";
import { useSelector } from "react-redux";
import { useGetPublicBookletQuery } from "../redux/booklet";
import { useContract } from "../hooks/nerdApp/nerdApp";

export function SeasonGreetings({
  token,
  seasonName,
  seasonCover,
}: {
  token: string;
  seasonName: string;
  seasonCover: string;
}) {
  const mission = useMissionMap(token);
  const CurrentStage = mission?.CurrentStage;
  const Interactors = mission?.Interactors;
  const { contract } = useContract();
  const dispatch = useDispatch();

  return (
    <Paper>
      <Box>
        {seasonCover ? (
          <img src={seasonCover} style={{ height: 100, borderRadius: "8px" }} />
        ) : (
          []
        )}
        <Typography level="title-lg">
          New Season from {mission?.CompanyName}
        </Typography>
        <Typography level="body-sm">
          Hello {mission?.MusicianName},
          <div
            style={{
              textAlign: "center",
              width: `calc(100vw - 32px)`,
              maxWidth: 450,
              padding: 0,
            }}
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: mission?.Greetings ?? "" }}
          />
        </Typography>
      </Box>
      <Typography level="title-lg" sx={{ mt: 1, mb: 1 }}>
        <i>&quot;{seasonName}&quot;</i>
      </Typography>
      {mission?.Memo ? <Memo compact memo={mission?.Memo} token={token} /> : []}
      {(!Interactors || Interactors.length === 0) && CurrentStage ? (
        <Alert
          size="sm"
          sx={{
            background: CurrentStage?.Color
              ? alpha(CurrentStage.Color, 0.1)
              : "#9e9e9e",
          }}
        >
          <Typography
            startDecorator={
              CurrentStage?.Icon ? (
                <img style={{ height: 14 }} src={CurrentStage?.Icon} />
              ) : undefined
            }
            sx={{ color: CurrentStage?.Color }}
            level="body-sm"
          >
            {CurrentStage?.Name}
          </Typography>
        </Alert>
      ) : (
        []
      )}
      <AskForRelease token={token} season />
      {contract?.signed() ? (
        <Button
          startDecorator={<i className="fa-solid fa-file-contract"></i>}
          size="sm"
          variant="soft"
          color="neutral"
          onClick={() => {
            dispatch(setSelectedBookletToken(mission?.BookletToken));
          }}
        >
          View my Contract
        </Button>
      ) : (
        []
      )}
      {contract && !contract?.signed() && !mission?.onboardingRequired() ? (
        <Button
          startDecorator={<i className="fa-solid fa-file-contract"></i>}
          size="sm"
          variant="solid"
          color="success"
          onClick={() => {
            dispatch(setSelectedBookletToken(mission?.BookletToken));
          }}
        >
          Sign my Contract
        </Button>
      ) : (
        []
      )}
      {!contract?.signed() && mission?.onboardingRequired() ? (
        <Button
          size="sm"
          variant="solid"
          color="success"
          endDecorator={
            <i className="fa-solid fa-arrow-up-right-from-square"></i>
          }
          onClick={() => {
            mission.onboardNow();
          }}
        >
          Onboard now
        </Button>
      ) : (
        []
      )}
      <SeasonCalendar />
    </Paper>
  );
}
